import styled from "styled-components";

export const Button = styled.button`
  position: fixed;
  bottom: 72px;
  right: 8px;
  z-index: 999;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.shades[0]};
  box-shadow: ${({ theme }) => theme.boxShadow};
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  > svg {
    width: 24px;
    height: 24px;
    > g, path {
      fill: ${({ theme }) => theme.colors.primary[500]};
    }
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    bottom: calc(72px + 8px + 40px);
  }
`;